import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardContent, Container } from '@material-ui/core';
import CustomTable from '../components/team/TableComponent';
import useVrackApi from '../hooks/useVrackApi';
import Page from '../components/Page';
import { snapshotColumns } from './Snapshots.columns';

export default function Snapshots() {
  const [snapshotList, setSnapshotList] = useState([]);
  const { fetchData: vrackApiGetSnapshotList } = useVrackApi('get', '/racks/snapshot');
  const navigate = useNavigate();
  const handleRowClick = (params) => {
    navigate(`/snapshots/details/${params.row.name}`);
  };
  const getSnapshotList = async () => {
    await vrackApiGetSnapshotList('get', '/racks/snapshot')
      .then((response) => {
        console.debug('Snapshots were successfully retrieved from the API');
        setSnapshotList(response);
      })
      .catch((error) => {
        console.debug(error);
      });
  };

  const columns = snapshotColumns(getSnapshotList, handleRowClick);

  useEffect(() => {
    getSnapshotList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="Snapshots | Virtual Racks">
      <Container maxWidth={false}>
        <Card>
          <CardHeader title="Snapshots" subheader="View and manage Snapshots" />
          <CardContent>
            <CustomTable data={snapshotList} getData={getSnapshotList} columns={columns} />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
